import { BaseResponse } from "../models/BaseResponse";
import { UserGetRequest } from "../models/UserGetRequest";
import { UserDeleteRequest } from "../models/UserDeleteRequest";
import { UserGetResponse } from "../models/UserGetResponse";
import { APIService } from "./APIService";
import { ProcessedResponse } from "../models/ProcessedResponse";
import { UserEnableDisableRequest } from "../models/UserEnableDisableRequest";
import { UserResetPasswordRequest } from "../models/UserResetPasswordRequest";
import { UserDetailGetResponse } from "../models/UserDetailGetResponse";
import { AuthUserResetPasswordRequest } from "../models/AuthUserResetPasswordRequest";
import { AuthUserResetPasswordResponse } from "../models/AuthUserResetPasswordResponse";
import { PaperPayslipChangeRequest } from "../models/PaperPayslipChangeRequest";
import { PaperPayslipChangeResponse } from "../models/PaperPayslipChangeResponse";
import { UserLoginActivityRequest } from "../models/UserLoginActivityRequest";
import { UserLoginActivityResponse } from "../models/UserLoginActivityResponse";
import { AdminUserCreateRequest } from "../models/AdminUserCreateRequest";
import { AdminUserCreateResponse } from "../models/AdminUserCreateResponse";
import { AuthUserEmailChangeRequest } from "../models/AuthUserEmailChangeRequest";
import { AuthUserEmailChangeResponse } from "../models/AuthUserEmailChangeResponse";
import { UserPayslipChangeReportRequest } from "../models/UserPayslipChangeReportRequest";
import { UserPayslipChangeReportResponse } from "../models/UserPayslipChangeReportResponse";
import { PensionSchemeAndPayGroupRequest } from "../models/PensionSchemeAndPayGroupRequest";
import { PensionSchemeAndPayGroupResponse } from "../models/PensionSchemeAndPayGroupResponse";
import { UserUnlockAccountRequest } from "../models/UserUnlockAccountRequest";
import { UserUnlockAccountResponse } from "../models/UserUnlockAccountResponse";


export class UserAPIService {
    private _apiService: APIService;

    constructor(){
        this._apiService = new APIService();
    }

    public async getUserDetails(token: string | null):Promise<BaseResponse<UserDetailGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserDetailGetResponse>, ''>("User/GetUserDetails", "POST", '', token);
    }

    public async getAllAdminUser(request: UserGetRequest, token: string | null):Promise<BaseResponse<UserGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserGetResponse>, UserGetRequest>("Admin/GetAdminUsers", "POST", request, token);
    }

    public async createAdminUser(request: AdminUserCreateRequest, token: string | null):Promise<BaseResponse<AdminUserCreateResponse>>{
        return this._apiService.sendRequest<BaseResponse<AdminUserCreateResponse>, AdminUserCreateRequest>("Admin/CreateAdminUser", "POST", request, token);
    }

    public async getAllPensioners(request: UserGetRequest, token: string | null):Promise<BaseResponse<UserGetResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserGetResponse>, UserGetRequest>("Admin/GetUsers", "POST", request, token);
    }

    public async getLoginActivities(request: UserLoginActivityRequest, token: string | null): Promise<BaseResponse<UserLoginActivityResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserLoginActivityResponse>, UserLoginActivityRequest>("Admin/LoginActivities", "POST", request, token);
    }

    public async getPayslipChangeReport(request: UserPayslipChangeReportRequest, token: string | null): Promise<BaseResponse<UserPayslipChangeReportResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserPayslipChangeReportResponse>, UserPayslipChangeReportRequest>("Admin/PayslipChangeReport", "POST", request, token);
    }

    public async deleteUser(request: UserDeleteRequest, token: string | null):Promise<BaseResponse<ProcessedResponse>>{
        return this._apiService.sendRequest<BaseResponse<ProcessedResponse>, UserDeleteRequest>("Admin/DeleteUsers", "POST", request, token);
    }

    public async enableDisableUser(request: UserEnableDisableRequest, token: string | null): Promise<BaseResponse<ProcessedResponse>>{
        return this._apiService.sendRequest<BaseResponse<ProcessedResponse>, UserEnableDisableRequest>("Admin/EnableDisableUsers", "POST", request, token);
    }

    public async unlockUserAccount(request: UserUnlockAccountRequest, token: string | null): Promise<BaseResponse<UserUnlockAccountResponse>>{
        return this._apiService.sendRequest<BaseResponse<UserUnlockAccountResponse>, UserUnlockAccountRequest>("Admin/UnlockUserAccount", "POST", request, token);
    }

    public async resetUserPassword(request: UserResetPasswordRequest, token: string | null): Promise<BaseResponse<ProcessedResponse>>{
        return this._apiService.sendRequest<BaseResponse<ProcessedResponse>, UserResetPasswordRequest>("Admin/ResetUserPassword", "POST", request, token);
    }

    public async resetPassword(request: AuthUserResetPasswordRequest, token: string | null): Promise<BaseResponse<AuthUserResetPasswordResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserResetPasswordResponse>, AuthUserResetPasswordRequest>("User/ChangePassword", "POST", request, token);
    }

    public async changeEmail(request: AuthUserEmailChangeRequest, token: string | null): Promise<BaseResponse<AuthUserEmailChangeResponse>>{
        return this._apiService.sendRequest<BaseResponse<AuthUserEmailChangeResponse>, AuthUserEmailChangeRequest>("User/UserEmailChange", "POST", request, token);
    }

    public async paperPayslipChange(request: PaperPayslipChangeRequest, token: string | null): Promise<BaseResponse<PaperPayslipChangeResponse>>{
        return this._apiService.sendRequest<BaseResponse<PaperPayslipChangeResponse>, PaperPayslipChangeRequest>("User/PayslipTypeChange", "POST", request, token);
    }

    public async getPensionSchemeAndPayGroup(request: PensionSchemeAndPayGroupRequest, token: string | null): Promise<BaseResponse<PensionSchemeAndPayGroupResponse>>{
        return this._apiService.sendRequest<BaseResponse<PensionSchemeAndPayGroupResponse>, PensionSchemeAndPayGroupRequest>("Admin/GetPensionSchemeAndPayGroupList", "POST", request, token);
    }
}